var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullCondor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 44V44.5H7H30.793H31.1236L31.2531 44.1957L35.0795 35.1996L35.0812 35.1957L40.8276 22H46.5033L51.5329 35.1783L51.6557 35.5H52H56.2617H56.9987L56.7263 34.8152L49.9646 17.8152L49.8392 17.5H49.5H37.5H37.1678L37.0391 17.8063L29.8958 34.8032L29.8945 34.8063L27.6702 40H7H6.5V40.5V44Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 44V44.5H7H30.793H31.1236L31.2531 44.1957L35.0812 35.1957L35.3771 34.5H34.6211H30.3555H30.0257L29.8958 34.8032L27.6702 40H7H6.5V40.5V44Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8263 44.5H55.4956L55.3662 44.1957L51.5381 35.1957L51.2422 34.5H51.9982H56.2638H56.5936L56.7234 34.8032L58.9491 40H61.2443H61.6742L61.7387 40.4251L62.2689 43.9251L62.356 44.5H61.7746H55.8263Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullCondor);
export default __webpack_public_path__ + "static/media/bull_condor.eb526034bea9d93414f38c7758f13e36.svg";
export { ForwardRef as ReactComponent };